import api from './api';

let showLoadingCallback: (() => void) | null = null;
let hideLoadingCallback: (() => void) | null = null;

// IDs dos interceptores registrados — usados para ejetar antes de re-registrar,
// evitando acumulação infinita de interceptores ao longo da sessão
let requestInterceptorId: number | null = null;
let responseInterceptorId: number | null = null;

export function setupApiLoadingInterceptors(
  showLoading: () => void,
  hideLoading: () => void
) {
  showLoadingCallback = showLoading;
  hideLoadingCallback = hideLoading;

  // Ejetar interceptores anteriores antes de registrar novos
  // (defesa contra chamadas múltiplas, ex: StrictMode em dev)
  if (requestInterceptorId !== null) {
    api.interceptors.request.eject(requestInterceptorId);
  }
  if (responseInterceptorId !== null) {
    api.interceptors.response.eject(responseInterceptorId);
  }

  // Interceptor para mostrar loading ao iniciar requisição
  requestInterceptorId = api.interceptors.request.use(
    (config) => {
      showLoadingCallback?.();
      return config;
    },
    (error) => {
      hideLoadingCallback?.();
      return Promise.reject(error);
    }
  );

  // Interceptor para esconder loading ao terminar requisição
  responseInterceptorId = api.interceptors.response.use(
    (response) => {
      hideLoadingCallback?.();
      return response;
    },
    (error) => {
      hideLoadingCallback?.();
      return Promise.reject(error);
    }
  );
}
